(() => {
  'use strict';
  const day = 86400000;
  const dateKey = date => date.toISOString().slice(0, 10);
  function holidays(year) {
    // Gregorian Easter; French nationwide public holidays.
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451), month = Math.floor((h + l - 7 * m + 114) / 31);
    const easterDay = ((h + l - 7 * m + 114) % 31) + 1;
    const easter = Date.UTC(year, month - 1, easterDay, 12);
    const dates = new Set(['01-01','05-01','05-08','07-14','08-15','11-01','11-11','12-25'].map(value => `${year}-${value}`));
    [1,39,50].forEach(offset => dates.add(dateKey(new Date(easter + offset * day))));
    return dates;
  }
  function businessDate(today, count) {
    let date = new Date(today), remaining = count;
    const years = new Map();
    while (remaining > 0) {
      date = new Date(date.getTime() + day);
      const year = date.getUTCFullYear();
      if (!years.has(year)) years.set(year, holidays(year));
      if (date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && !years.get(year).has(dateKey(date))) remaining--;
    }
    return date;
  }
  function update(scope = document) {
    const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/Paris',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date()).map(part => [part.type,part.value]));
    const today = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12));
    scope.querySelectorAll('[data-delivery-estimate]').forEach(node => {
      const minimum = Math.min(20, Math.max(1, Number(node.dataset.minDays) || 3));
      const maximum = Math.max(minimum, Math.min(30, Number(node.dataset.maxDays) || 7));
      const formatter = new Intl.DateTimeFormat(node.dataset.locale || 'fr-FR', {day:'numeric',month:'long',timeZone:'UTC'});
      node.querySelector('[data-delivery-dates]').textContent = node.dataset.dateLabel.replace('{start}',formatter.format(businessDate(today, minimum))).replace('{end}',formatter.format(businessDate(today, maximum)));
      const selected = node.closest('[data-product]')?.querySelector('[data-variant-select]')?.selectedOptions[0];
      if (selected) node.hidden = selected.dataset.available !== 'true' || selected.dataset.stock !== 'true';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => update()); else update();
  document.addEventListener('change', event => { if (event.target.matches('[data-variant-select]')) update(event.target.closest('[data-product]')); });
  document.addEventListener('shopify:section:load', event => update(event.target));
  window.addEventListener('pageshow', () => update());
})();
